import { SVGProps } from "react";

export function TrendUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.375 7.125L9.225 10.275L8.025 8.475L5.625 10.875"
        stroke="currentColor"
        strokeWidth="0.84375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.875 7.125H12.375V8.625"
        stroke="currentColor"
        strokeWidth="0.84375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
